@if (showConsent) {
    <div class="PGCookieConsent">
        <div class="modal-backdrop fade show"></div>
        <div class="modal d-block fade show" role="dialog" aria-modal="true" aria-labelledby="pg-cookie-consent-title">
            <div class="modal-dialog text-center">
                <div class="modal-content">
                    <div class="modal-body">
                        <div id="pg-cookie-consent-title" class="mb-1">{{ 'pg-cookie-consent.popup-text' | locTranslate }}</div>
                        <div class="d-flex justify-content-evenly mb-3">
                            @if (privacyPolicyURL != null) {
                                <a target="_blank" rel="noopener noreferrer" [href]="privacyPolicyURL" class="mx-1">
                                    {{ 'pg-cookie-consent.popup-link-privacy-policy' | locTranslate }}
                                    <span class="visually-hidden">{{ 'pg-cookie-consent.opens-new-window' | locTranslate }}</span>
                                </a>
                            }
                            <button type="button" class="btn btn-link mx-1 p-0 align-baseline" (click)="customizeCookies = !customizeCookies" [attr.aria-expanded]="customizeCookies">
                                {{ 'pg-cookie-consent.customize-cookies' | locTranslate }}
                            </button>
                        </div>
                        @if(customizeCookies) {
                            <div class="d-flex justify-content-center border-top">
                                <div class="mt-3 mx-2">
                                    @for (config of consentConfig; track config) {
                                        <div class="px-1 my-1 text-start">
                                            <div class="form-check form-check-inline m-0">
                                                <input id="PGCookieConsent_{{config.id}}" class="form-check-input" type="checkbox" [disabled]="config.required" [checked]="consentData[config.id]" (change)="consentData[config.id] = !consentData[config.id]"/>
                                                <label for="PGCookieConsent_{{config.id}}" class="form-check-label">{{ 'pg-cookie-consent.cookie-type-' + config.id | locTranslate }}</label>
                                            </div>
                                        </div>
                                    }
                                    <button type="button" class="btn btn-primary my-3" (click)="saveConsent()">{{ 'pg-cookie-consent.button-accept-selected' | locTranslate }}</button>
                                </div>
                            </div>
                        }
                        <div class="border-top">
                            <button type="button" class="btn btn-primary mx-2 mt-3" (click)="saveConsent('none')">{{ 'pg-cookie-consent.button-reject' | locTranslate }}</button>
                            <button type="button" class="btn btn-primary mx-2 mt-3" (click)="saveConsent('all')">{{ 'pg-cookie-consent.button-accept' | locTranslate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
